import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LiftTemperatureService {
  apiUrl: string;
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl + 'api/Statistics';
  }

  getTemperatures(params: HttpParams) {
    const url = this.apiUrl + '/GetTemperature';

    return this.httpClient.get<any>(url, { params: params });
  }
}
